import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './SegmentedControl.scss';
const SegmentedControl = ({ options, value, onChange, name, // Use the name prop for radio group
disabled = false, id, 'aria-labelledby': ariaLabelledby }) => {
    return (_jsx("div", { className: `segmented-control ${disabled ? 'disabled' : ''}`, role: "radiogroup", id: id, "aria-labelledby": ariaLabelledby, children: options.map((option, index) => {
            const optionId = `${id || name}-${option.value}-${index}`; // Unique ID for each radio/label pair
            return (_jsxs(React.Fragment, { children: [_jsx("input", { type: "radio", id: optionId, name: name, value: option.value, checked: option.value === value, onChange: () => onChange(option.value), disabled: disabled, className: "segmented-control-input" }), _jsx("label", { htmlFor: optionId, className: "segmented-control-label", children: option.label })] }, optionId));
        }) }));
};
export default SegmentedControl;
